import PortalIdParser from 'PortalIdParser';
import { createNewDefaultForm } from 'FormsUI/api/NewEditorCreation';
import { FAIL_CREATING_FORM, REQUEST_FORM_CREATION, SUCCEED_CREATING_FORM } from 'FormsUI/actions/formCreation/formCreationActions';
import { getSelectedBusinessUnitId } from 'FormsUI/selectors/FormCreation';
import redirectToNewEditor from 'FormsUI/actions/formCreation/newEditor/redirectToNewEditor';
import createNewEditorError from 'FormsUI/actions/formCreation/newEditor/createNewEditorError';
export const createNewEditorForm = (creationType = 'firstLaunch') => async (dispatch, getState) => {
  const state = getState();
  const portalId = PortalIdParser.get();
  const businessUnitId = getSelectedBusinessUnitId(state);
  if (!portalId) return;
  try {
    dispatch({
      type: REQUEST_FORM_CREATION
    });
    const {
      id
    } = await createNewDefaultForm({
      businessUnitId
    });
    dispatch({
      type: SUCCEED_CREATING_FORM
    });
    redirectToNewEditor(id, creationType);
  } catch (error) {
    dispatch({
      type: FAIL_CREATING_FORM
    });
    dispatch(createNewEditorError(error));
  }
};